<content>
    <section class="filters-framed">
        <form [formGroup]="newFormCompleta">
            <div class="info">{{'global.infoRequired' | translate}}</div>
            <div class="entry-3-modal">
                <label>{{'mantenimientoConfecciones.confeccion.confeccion' | translate}} *</label>
                <input type="text" formControlName="des">
            </div>
            <div class="entry-3-modal">
                <label>{{'mantenimientoConfecciones.confeccion.alias' | translate}}</label>
                <input type="text" formControlName="alias">
            </div>
            <div class="entry-3-modal">
                <label>{{'mantenimientoConfecciones.confeccion.etiquetador' | translate}} *</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="newFormCompleta.get('etiquetador')"
                    [disabled]="disabledEtiquetadores" [placeHolder]="false"></app-filterable-list>
            </div>
            <div class="entry-3-modal">
                <label>{{'mantenimientoConfecciones.confeccion.tipoConfeccion'| translate}} *</label>
                <app-filterable-list [itemsList]="tiposConfeccion"
                    [selectedItem]="newFormCompleta.get('tipoConfeccion')" [disabled]="disabledForm"
                    [placeHolder]="false"></app-filterable-list>
            </div>
            <div class="entry-3-modal">
                <label>{{'mantenimientoConfecciones.confeccion.pesoPallet' | translate}}</label>
                <input type="number" readonly formControlName="pesoPallet">
            </div>
        </form>
    </section>
    <div class="table-modal">
        <h4><span class="underline">{{'mantenimientoConfecciones.confeccion.cajasConfeccion.tituloParte1' |
                translate}}</span>{{'mantenimientoConfecciones.confeccion.cajasConfeccion.tituloParte2' |
            translate}}<span>{{'mantenimientoConfecciones.confeccion.cajasConfeccion.tituloParte3' |
                translate}}</span>{{'mantenimientoConfecciones.confeccion.cajasConfeccion.tituloParte4' | translate}}
        </h4>
        <table>
            <thead>
                <tr>
                    <th>{{'mantenimientoConfecciones.confeccion.cajasConfeccion.denominacion' | translate}}</th>
                    <th>{{'mantenimientoConfecciones.confeccion.cajasConfeccion.caja' | translate}}</th>
                    <th>{{'mantenimientoConfecciones.confeccion.cajasConfeccion.numCajas' | translate}}</th>
                    <th class="action">
                        <i class="fas fa-plus" *ngIf="this.etiquetadorId !== null" (click)="newCajas=true;"></i>
                    </th>
                </tr>
            </thead>
            <tbody>
                <app-cajas-pallet-component class="component-in-row" *ngIf="newCajas" [editable]="true"
                    [denominaciones]="denominaciones" [etiquetadorId]="this.etiquetadorId" [idTabla]="idTabla"
                    (close)="newCajas=$event" (refreshAdd)="refreshAddCajas($event)">
                </app-cajas-pallet-component>
                <app-cajas-pallet-component class="component-in-row" *ngFor="let cajaPallet of cajasPallet"
                    [denominaciones]="denominaciones" [etiquetadorId]="this.etiquetadorId" [caja]="cajaPallet"
                    [editable]="false" [idTabla]="idTabla" (refreshRemove)="refreshRemove($event)">
                </app-cajas-pallet-component>
            </tbody>
        </table>
    </div>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="addCompleta()">{{'global.insertar' | translate}}</button>
</footer>
<app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
<div class="modal" *ngIf="simpleModal">
    <div class="modal-content">
        <header>
            <h4>{{'mantenimientoConfecciones.confeccion.insertSimple.titulo' | translate}}</h4>
        </header>
        <content>
            <p>{{'mantenimientoConfecciones.confeccion.insertSimple.descripcion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary">{{'global.si' | translate}}</button>
            <button>{{'global.no' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="resumenModal">
    <div class="modal-content">
        <header>
            <h4>Confección Completa</h4>
        </header>
        <content>
            <h4>Se va a insertar una confección con los siguientes datos: </h4>
            <p> Confección: {{this.newFormCompleta.get('des').value}}</p>
            <p>Etiquetador: {{this.newFormCompleta.get('etiquetador').value.des}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="resumenModal = false">{{'global.cancelar' | translate}}</button>
            <button (click)="addCompleta()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>